export enum ShipmentCreationTemplateTypes {
  Basic = 'BASIC',
  Cement = 'CEMENT',
  Orders = 'ORDER_ORIENTED',
  Bidding = 'BIDDING',
  Growth = 'GROWTH',

  /**
   * A way of CREATING shipments, not a template a customer can be assigned.
   *
   * It lives here so both "create shipment" menus offer it without either of them hard-coding
   * an extra entry — they simply list this enum. It is never a shipment's own
   * `creationTemplateType`, and the three screens that turn this enum into options sent to the
   * server (`customers-template-assignment`, `dynamic-integration` and `user-params`) filter it
   * out for exactly that reason.
   */
  Import = 'IMPORT',
}
